import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";

import { useStyles } from "./UserProfile.css";
import UserHeader from "../../../Components/NavBar/User/UserHeader/UserHeader";
import { connect } from "react-redux";
import Axios from "axios";
import { url } from "../../../Config/Config";
import StudentDetails from "./StudentDetails";
import TeacherDetails from "./TeacherDetails";
import { getUserRefreshToken } from "../../../Redux/Actions/actions";

class UserProfile extends Component {
  constructor(props) {
    super(props);
    this.state = { userDetails: {} };
  }

  componentDidMount() {
    this.getUserDetails();
  }

  getUserDetails = async (userId) => {
    try {
      let userDetails = {};
      if (this.props.role === "Teacher") {
        const teacherResponse = await Axios.get(
          `${url}/api/staffs/teacher/${userId}`,
          {
            headers: {
              Authorization: `Bearer ${this.props.userToken}`,
            },
          }
        );
        userDetails = teacherResponse.data.teacher;
      } else {
        const studentResponse = await Axios.get(
          `${url}/api/students/${userId}`,
          {
            headers: {
              Authorization: `Bearer ${this.props.userToken}`,
            },
          }
        );
        userDetails = studentResponse.data.student;
      }
      this.setState({ userDetails });
    } catch (error) {
      if (
        error.response.data === "jwt expired" &&
        error.response.status === 401
      ) {
        console.clear();
        let refreshToken = { refreshToken: this.props.userRefreshToken };
        this.props.getUserRefreshToken(refreshToken, this.props.role);
        this.getUserDetails(userId);
      }
    }
  };

  render() {
    const { classes } = this.props;
    const { userDetails } = this.state;
    return (
      <div className={classes.root}>
        <UserHeader />
        <div className={classes.content}>
          <div className={classes.toolbar} />
          {this.props.role === "Teacher" ? (
            <TeacherDetails userDetails={userDetails} />
          ) : (
            <StudentDetails userDetails={userDetails} />
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    userId: state.UserReducer.userId,
    userToken: state.UserReducer.userToken,
    userRefreshToken: state.UserReducer.userRefreshToken,
    role: state.UserReducer.role,
    isUser: state.UserReducer.isUser,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getUserRefreshToken: (refreshToken, role) => {
      dispatch(getUserRefreshToken(refreshToken, role));
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(useStyles)(UserProfile));
